import React, {useEffect, useState} from 'react';
import { exportAll } from '../resources/main.js';

import {

  Button,
} from '@awsui/components-react';

import { useMFApps } from "../actions/ApplicationsHook";
import { useGetServers } from "../actions/ServersHook.js";
import { useMFWaves } from "../actions/WavesHook.js";
import { useGetDatabases} from "../actions/DatabasesHook";
import { useProgressModal } from "../actions/ProgressModalHook.js";

const UserExport = (props) => {

  //Data items for viewer and table.
  const [{ isLoading: isLoadingApps, data: dataApps, error: errorApps }, { update: updateApps }] = useMFApps();
  const [{ isLoading: isLoadingServers, data: dataServers, error: errorServers }, { update: updateServers }] = useGetServers();
  const [{ isLoading: isLoadingWaves, data: dataWaves, error: errorWaves }, { update: updateWaves }] = useMFWaves();
  const [{ isLoading: isLoadingDBs, data: dataDBs, error: errorDbs }, { update: updateDBs }] = useGetDatabases();
  const { show: showCommitProgress, hide: hideCommitProgress, setProgress: setImportProgress, RenderModal: CommitProgressModel } = useProgressModal()

  function exportClick() {

    let data = {};
    data.servers = dataServers;
    data.applications = dataApps;
    data.waves = dataWaves;
    data.databases = dataDBs;
    exportAll(data, "all-data");

  }

  function exportServersAudit() {

    let data = {};
    data.servers = dataServers;
    var servers = []
    var statusTypes = [undefined, "2 - Pending", "0 - Blocked", "1 - Commenced"]
    for(var item in dataServers){
      if(statusTypes.includes(dataServers[item].t100_status)){
        if(dataServers[item].migration_treatment !== "PeopleSoft"){
          var object = {}
          object.server_name = dataServers[item].server_name
          object.server_id = dataServers[item].server_id
          object.app_id = dataServers[item].app_id
          object.faculty = dataServers[item].faculty
          object.t100_status = dataServers[item].t100_status
          object.business_partner = dataServers[item].business_partner
          object.business_owner = dataServers[item].business_owner
          object.technical_owner = dataServers[item].technical_owner
          object.migration_treatment = dataServers[item].migration_treatment
          if(dataServers[item]._history === undefined){
            object.lastModifiedBy = ""
            object.lastModifiedTimestamp = ""
          }
          else if("lastModifiedBy" in dataServers[item]._history){
            object.lastModifiedBy = dataServers[item]._history.lastModifiedBy.email
            object.lastModifiedTimestamp = dataServers[item]._history.lastModifiedTimestamp
          }
          else{
            object.lastModifiedBy = ""
            object.lastModifiedTimestamp = ""
          }
          var date = new Date(object.lastModifiedTimestamp)
          var currentDate = Date.now()
          var difference = currentDate - date
          var millisecondsPerDay = 24 * 60 * 60 * 1000;
          var numDays = difference / millisecondsPerDay
          if(isNaN(numDays)){
            object.audit_status = "Red"
          }
          else if(numDays < 21){
            object.audit_status = "Green"
          }
          else if(numDays < 40){
            object.audit_status = "Amber"
          }
          else{
            object.audit_status = "Red"
          }
          servers.push(object)
        }
      }
    }
    data.servers = servers
    exportAll(data, "server-audit-data");

  }

  //Check if any data is still loading and disable download button.
  let dataLoading = isLoadingApps || isLoadingServers || isLoadingWaves

  //Update help tools panel.
  useEffect(() => {
    props.setHelpPanelContent({
      header: 'Export',
      content_text: 'From here you can export all the data from the Cloud Migration Tracker into a single multi tabbed Excel spreadsheet.'
    })
  }, []);

  return (
    <div>
      {<Button variant="primary" iconName="download" disabled={dataLoading} onClick={() => {
          exportClick();
        }}>Download All Data</Button>}
      {<Button variant="primary" iconName="download" disabled={dataLoading} onClick={() => {
          exportServersAudit();
        }}>Download Audit</Button>}
      </div>
  );
};

// Component TableView is a skeleton of a Table using AWS-UI React components.
export default UserExport;
